import React, {Component} from 'react';
import {Row, Col, FormGroup, Form, ButtonToolbar} from "react-bootstrap";
import {TopButtonAction, TopButtonCancel} from "../../../../../../../componentsTopsa/buttons/TopButtons";
import ObsadaService from "../../../ObsadaService";
import ObsadaListaForm from "../../../ObsadaLista/components/ObsadaListaForm";
import TrasyService from "../../../../../trasyConfig/trasy/TrasyService";

export default class KalendarzModalDuplikujKurs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            event: this.props.event,
            czyZapisano: null,
        };
        this.onClickZapisz = this.onClickZapisz.bind(this)
    }

    componentDidMount() {
        this.setState({event: this.props.event})
    }

    componentWillReceiveProps(nextprops) {
        this.setState({
            event: nextprops.event,
        })
    }

    renderStatusKursu() {
        if (this.state.event.zablokowane === 0) {
            return <span style={{color: 'forestgreen'}}><i className={'fa fa-check'}></i> dostępny</span>
        }
        else if (this.state.event.zablokowane === 1) {
            return <span style={{color: 'darkorange'}}><i className={'fa fa-times'}></i> zablokowany</span>
        }
        else if (this.state.event.zablokowane === 2) {
            return <span style={{color: 'firebrick'}}><i className={'fa fa-repeat'}></i> odwołany</span>
        }
    }

    onClickZapisz(obj) {
        ObsadaService.addObsadaBis(obj).then(function (response) {
            if (response.status < 300) {
                this.setState({czyZapisano: true})
                setTimeout(function () {
                    this.props.afterClickZapisz(response.data,'duplikacja', obj);
                }.bind(this), 3000)
            }
            else {
                this.setState({czyZapisano: false})
            }
        }.bind(this))
    }

    render() {

        return (
            <div>
                {
                    (this.state.czyZapisano === null) ?
                        <div style={{width: '960px'}}>
                            <h3 style={{textAlign: 'center'}}>
                                Kurs nr <span className={'label label-ebus-primary'} style={(this.state.event.zablokowane == 2) ? {
                                fontSize: 'inherit',
                                background: 'grey'
                            } : {fontSize: 'inherit'}}>{this.state.event.id_ku}</span> {this.renderStatusKursu()}
                            </h3>
                            <div style={{marginTop: '25px'}}>
                                <ObsadaListaForm handleClickAnuluj={() => {
                                    this.props.onClickAnuluj()
                                }}
                                                 trasy={this.props.trasy}
                                                 handleClickZapisz={this.onClickZapisz}
                                                 duplikowanaObsada={this.state.event}
                                />
                            </div>
                        </div>
                        :
                        <div>
                            {
                                (this.state.czyZapisano) ?
                                    <h3>
                                        <i className={'fa fa-check'} style={{color: 'forestgreen'}}></i> Pomyślnie zapisano zmiany
                                        <div>
                                            <small><i className={'fa fa-circle-o-notch fa-spin'}></i> Za chwilę nastąpi odświeżenie kalendarza...
                                            </small>
                                        </div>
                                    </h3>
                                    :
                                    <h3>
                                        <i className={'fa fa-times'} style={{color: 'firebrick'}}></i> Wystąpił błąd podczas akcji
                                    </h3>
                            }
                        </div>
                }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/obsada/ObsadaKalendarz/components/modalComponents/KalendarzModalDuplikujKurs.js